import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {TranslatePipe} from "./translate.pipe";
import {SafePipe} from './components/+gameevent/safe-pipe';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    TranslatePipe,
    SafePipe
  ],
  imports: [CommonModule],
  providers: [
  ],
  exports : [
    TranslatePipe,
    SafePipe
  ],
})
export class TranslateModule { }




// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/translate-module.ts